import { useEffect, useCallback } from "react";
import { useSettings } from "utils/settingsContext";
import { isRedirectURLAllowed } from "utils/redirect";
import { useSessionJWT } from "utils";
import { logInfo } from "api/accounts-customer";

/**
 * AllowedOriginValidationCheckHandler
 * @description Component to listen for and response to requests to validate a redirect url
 * against an integrator based list of allowed origin domain patterns.
 * It first adds an event listener for messages and looks out for one with type:
 * "request-return-url-validation"
 * This component is added after the post-auth stuff so it can access integrator settings.
*/

const AllowedOriginValidationCheckHandler = () => {
  const { integratorSettings } = useSettings();
  const { sessionJWT } = useSessionJWT();

  const messageListener = useCallback((message) => {
    const messageIsFromTiliaHost = message?.origin && message.origin.endsWith(".tilia-inc.com"); // TODO: This is a pretty tight lock to 'tilia-inc.com', we'll have to update if we do anything with the domain address
    const type = message?.data?.type === "request-return-url-validation";
    const url = message?.data?.url;
    if (messageIsFromTiliaHost && type && url) {
      const isAllowed = isRedirectURLAllowed(url, integratorSettings);
      logInfo(sessionJWT, {
        flowLoc: "AllowedOriginValidationCheckHandler",
        event: "request-return-url-validation",
        url,
        isAllowed,
      });
      if (window?.parent?.postMessage) {
        window.parent.postMessage(
          { source: "tilia", event: "return-url-validation-response", url, isAllowed },
          "*"
        );
      }
    }
  }, [integratorSettings, sessionJWT]);

  useEffect(() => {
    window.addEventListener("message", messageListener);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, [messageListener]);
  return <></>;
};

export default AllowedOriginValidationCheckHandler;
